import React, { Component } from 'react';

export class ResizeDetector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
    this.elementRef = null;
    this.attachRef = this.attachRef.bind(this);
    this.checkDimensions = this.checkDimensions.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.resizeObserver = null;
  }

  componentDidMount() {
    this.checkDimensions();
    window.addEventListener('resize', this.checkDimensions);

    // Set up ResizeObserver if it's available in the browser
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.handleResize);
      if (this.elementRef) {
        this.resizeObserver.observe(this.elementRef);
      }
    } else {
      // Fallback to polling for browsers that don't support ResizeObserver
      this.interval = setInterval(this.checkDimensions, 5000);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkDimensions);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  handleResize(entries) {
    if (!entries || !entries.length) return;

    const entry = entries[0];
    const { width, height } = entry.contentRect;

    if (width !== this.state.width || height !== this.state.height) {
      if (this.props.onResize) {
        this.props.onResize(entries);
      }

      this.setState({
        width,
        height
      });
    }
  }

  attachRef(node) {
    // Clean up previous observer if element reference changes
    if (this.resizeObserver && this.elementRef) {
      this.resizeObserver.unobserve(this.elementRef);
    }

    this.elementRef = node;

    // If element reference exists and observer is available, start observing
    if (node && this.resizeObserver) {
      this.resizeObserver.observe(node);
      this.checkDimensions();
    }
  }

  checkDimensions() {
    if (!this.elementRef) return;

    const newWidth = this.elementRef.offsetWidth;
    const newHeight = this.elementRef.offsetHeight;

    if (newWidth !== this.state.width || newHeight !== this.state.height) {
      const dimensions = { width: newWidth, height: newHeight };

      if (this.props.onResize) {
        this.props.onResize([{
          target: this.elementRef,
          contentRect: dimensions
        }]);
      }

      this.setState(dimensions);
    }
  }

  render() {
    const { children, style } = this.props;
    return (
      <div ref={this.attachRef} style={style}>
        {children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/ResizeDetector/index.js